(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/participants/assets/javascripts/participants-names.js') >= 0) return;  svs.modules.push('/components/lb-ui/participants/assets/javascripts/participants-names.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useMemo = _React.useMemo;
const _svs$components$lbUi$ = svs.components.lbUi.participants,
  SmartAbbr = _svs$components$lbUi$.SmartAbbr,
  _svs$components$lbUi$2 = _svs$components$lbUi$.constants,
  getTeamName = _svs$components$lbUi$2.getTeamName,
  DescriptionSize = _svs$components$lbUi$2.DescriptionSize;
const clx = svs.components.lbUtils.clx;
const getTeamNameAndTitle = (participant, nameSize) => {
  const name = getTeamName(participant, nameSize);
  const title = (participant === null || participant === void 0 ? void 0 : participant.name) || name;
  return [name, title];
};
const ParticipantName = _ref => {
  let className = _ref.className,
    participant = _ref.participant,
    _ref$nameSize = _ref.nameSize,
    nameSize = _ref$nameSize === void 0 ? DescriptionSize.Medium : _ref$nameSize;
  const _useMemo = useMemo(() => getTeamNameAndTitle(participant, nameSize), [participant, nameSize]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    teamName = _useMemo2[0],
    teamTitle = _useMemo2[1];
  return React.createElement("span", {
    className: clx('participant', className)
  }, React.createElement(SmartAbbr, {
    title: teamTitle
  }, teamName));
};
const ParticipantsNames = _ref2 => {
  let awayParticipant = _ref2.awayParticipant,
    homeParticipant = _ref2.homeParticipant,
    _ref2$nameSize = _ref2.nameSize,
    nameSize = _ref2$nameSize === void 0 ? DescriptionSize.Medium : _ref2$nameSize,
    subDescription = _ref2.subDescription;
  return React.createElement(React.Fragment, null, React.createElement(ParticipantName, {
    className: "home-participant",
    nameSize: nameSize,
    participant: homeParticipant
  }), React.createElement("span", {
    className: "participant-split"
  }, " - "), React.createElement(ParticipantName, {
    className: "away-participant",
    nameSize: nameSize,
    participant: awayParticipant
  }), subDescription && React.createElement("div", {
    className: "participants-sub-description"
  }, subDescription));
};
setGlobal('svs.components.lbUi.participants', {
  ParticipantName,
  ParticipantsNames
});

 })(window);